import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import { Container, Tab, Tabs, Card } from "react-bootstrap";
import SearchFilter from "../../../components/SearchFilter";
import Table from "../../../components/Table";
import ConfigureColumnsDisplay from "../../../components/ConfigureColumnsDisplay";

export default function AdjustPlan() {
  const [loading, setLoading] = useState(false);
  const [tabKeys, setTabKeys] = useState("listPM");
  const [searchValue, setSearchValue] = useState({ listPM: [], roadmapPM: [] });
  const [data, setData] = useState({
    listPM: [
      {
        id: 1,
        year: "2023",
        customer_code_BP: "C5022011267",
        customer_branch_code: "0012",
        customer_name_branch: "มีนบุรี",
        team_master_name: "ทีมทดสอบ",
        month: "4",
        pm_round_number: "1",
        product_code: null,
        product_details: "เครื่องกรองน้ำ SSP",
        product_type: null,
        job_type: "PM",
        pm_round_number: "1",
        pm_plan_repair_number: "09220001-001",
        work_order_number: "FSR#2565/04/4096/1",
        issue_date_date_repair: "20/03/2023",
        machine_number: ""
      }
    ],
    roadmapPM: []
  });
  const [columns, setColumns] = useState({ listPM: [], roadmapPM: [] });
  const [selectedOptions, setSelectedOptions] = useState([
    "job_type",
    "pm_plan_repair_number",
    "work_order_number",
    "issue_date_date_repair",
    "product_details",
    "machine_number",
    "tag_filter",
    "parts_equipment_life_month",
    "age_start_date",
    "expirate_date",
    "work_completion_date"
  ]);
  const columnOptions = [
    { value: "job_type", label: "ประเภทงาน" },
    { value: "pm_round_number", label: "รอบ PM ครั้งที่" },
    { value: "month", label: "เดือน" },
    { value: "pm_plan_repair_number", label: "หมายเลขแผน PM/หมายเลขแจ้งซ่อม" },
    { value: "work_order_number", label: "เลขที่ใบสั่งงาน" },
    {
      value: "issue_date_date_repair",
      label: "วันที่ออกใบสั่งงาน/วันที่แจ้งซ่อม"
    },
    { value: "customer_branch_code", label: "รหัสสาขา (ลูกค้า)" },
    { value: "customer_branch_name", label: "ชื่อสาขา/ลูกค้า" },
    { value: "team_master_name", label: "ชื่อทีม/หัวหน้าช่าง" },
    { value: "product_details", label: "รายละเอียดสินค้า" },
    { value: "machine_number", label: "หมายเลขเครื่องจักร (Mc No.)" },
    { value: "tag_filter", label: "Tag-ชุดกรอง" },
    {
      value: "parts_equipment_life_month",
      label: "อายุอุปกรณ์อะไหล่ (เดือน)"
    },
    { value: "age_start_date", label: "วันที่เริ่มต้นอายุ" },
    { value: "expirate_date", label: "วันสิ้นสุดอายุ" },
    { value: "filter_status", label: "สถานะชุดกรอง" },
    { value: "date_filter_replacement", label: "วันที่เปลี่ยนชุดกรอง" },
    { value: "Working_day_between", label: "วันเข้าทำงานระหว่างวันที่" },
    { value: "until_date", label: "ถึงวันที่" },
    { value: "work_completion_date", label: "วันที่ทำงานเสร็จ" },
    { value: "work_details", label: "รายละเอียดการทำงาน" },
    { value: "technician", label: "ช่างผู้ปฎิบัติงาน" },
    { value: "remark", label: "หมายเหตุ" }
  ];
  const searchField = [
    { name: "year", label: "ปี", classNames: { label: "mb-3" }, size: 2 },
    {
      name: "customer_code_BP",
      label: "รหัสลูกค้า (BP code)",
      classNames: { label: "mb-3" },
      size: 3
    },
    {
      name: "customer_branch_code",
      label: "รหัสสาขา (ลูกค้า)",
      classNames: { label: "mb-3" },
      disabled: true,
      type: "text",
      size: 1,
      value: ""
    },
    {
      name: "customer_name_branch",
      label: "ชื่อลูกค้า/สาขา",
      classNames: { label: "mb-3" },
      disabled: true,
      type: "text",
      size: 3,
      value: ""
    },
    {
      name: "team_master_name",
      label: "ชื่อทีม/หัวหน้าช่าง",
      classNames: { label: "mb-3" },
      size: 3
    },
    { name: "month", label: "เดือน", classNames: { label: "mb-3" }, size: 2 },
    {
      name: "pm_round_number",
      label: "รอบ PM ครั้งที่",
      classNames: { label: "mb-3" },
      size: 2
    },
    {
      name: "product_code",
      label: "รหัสสินค้า",
      size: 3,
      classNames: { label: "mb-3" }
    },
    {
      name: "product_details",
      label: "รายละเอียดสินค้า",
      classNames: { label: "mb-3" },
      disabled: true,
      type: "text",
      size: 2,
      value: ""
    },
    {
      name: "product_type",
      label: "ชนิดสินค้า",
      classNames: { label: "mb-3" },
      size: 3
    }
  ];

  useEffect(() => {
    setColumns((prevCol) => ({
      ...prevCol,
      [tabKeys]: [
        {
          name: "ลำดับ",
          selector: (row) => row.rowIndex,
          sortable: true,
          width: "110px"
        }
      ]
    }));

    const newColumns = columnOptions
      .filter((option) => selectedOptions.includes(option.value))
      .map((option) => ({
        name: option.label,
        selector: (row) => row[option.value]
      }));

    setColumns((prevCol) => ({
      ...prevCol,
      [tabKeys]: [...prevCol[tabKeys], ...newColumns]
    }));
  }, [selectedOptions, tabKeys]);

  useEffect(() => {
    setTimeout(() => setLoading(false), 1000);
  }, []);

  return (
    <>
      <Helmet>
        <meta name="description" content="AdustPM " />
      </Helmet>
      <Container fluid className="p-0">
        <Tabs justify defaultActiveKey="listPM" onSelect={(k) => setTabKeys(k)}>
          <Tab eventKey="listPM" title="รายการเคลื่อนไหวของแผน PM">
            <Card className="m-1 mb-4 p-4 border-0">
              <Card.Body>
                <SearchFilter
                  data={data.listPM}
                  inputField={searchField}
                  fieldClassName={{ actionButton: "mb-1 py-2 text-center" }}
                  searchCallback={(search) =>
                    setSearchValue((prevState) => ({
                      ...prevState,
                      listPM: search
                    }))
                  }
                />
              </Card.Body>
            </Card>

            <Card className="m-1 mb-4 p-4 border-0">
              <Card.Header className="p-3 d-flex justify-content-between align-items-center border-bottom-0 bg-transparent">
                <Card.Title className="mb-0 fs-2">รายการเคลื่อนไหว</Card.Title>

                <ConfigureColumnsDisplay
                  options={columnOptions}
                  selectedOptions={selectedOptions}
                  onSelect={(values) => setSelectedOptions(values)}
                />
              </Card.Header>

              <Card.Body>
                <Table
                  data={data.listPM}
                  column={columns.listPM}
                  searchFilter={searchValue.listPM}
                  pending={loading}
                  pagination
                />
              </Card.Body>
            </Card>
          </Tab>

          <Tab eventKey="roadmapPM" title="แผนงาน PM ที่ปรับปรุงแล้ว">
            <Card className="m-1 mb-4 p-4 border-0">
              <Card.Body>
                <SearchFilter
                  inputField={searchField}
                  data={data.roadmapPM}
                  fieldClassName={{ actionButton: "mb-1 py-2 text-center" }}
                  searchCallback={(search) => {
                    setSearchValue((prevState) => ({
                      ...prevState,
                      roadmapPM: search
                    }));
                  }}
                />
              </Card.Body>
            </Card>

            <Card className="m-1 mb-4 p-4 border-0">
              <Card.Header className="p-3 d-flex justify-content-between align-items-center border-bottom-0 bg-transparent">
                <Card.Title className="mb-0 fs-2">รายการเคลื่อนไหว</Card.Title>

                <ConfigureColumnsDisplay
                  options={columnOptions}
                  selectedOptions={selectedOptions}
                  onSelect={(values) => setSelectedOptions(values)}
                />
              </Card.Header>

              <Card.Body>
                <Table
                  data={data.roadmapPM}
                  column={columns.roadmapPM}
                  searchFilter={searchValue.roadmapPM}
                  pending={loading}
                  pagination
                />
              </Card.Body>
            </Card>
          </Tab>
        </Tabs>
      </Container>
    </>
  );
}
